module.exports = __webpack_public_path__ + "static/img/cloud_xpress_connect_banner_bg.56525bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud_xpress_connect_banner_bg.jpg
// module id = ruJ5
// module chunks = 0